<template>
  <div 
    class="j_dashboard_layout_builder__"
    :id='localId' 
    :style="styleWrapper"
    >
    <div class="contents_block_">
      <article 
        class="j_dashboard_layout_grid"
        :style="styleGrid"
      >
        <section 
          v-for="(container, i) in containers" 
          class="_dashboard_section_container__" 
          :id="`container__${i}_${localId}`"
          :key="`container__${i}_${localId}`"
          :style="styleContainer(container)"
          @click="onSelect(i)"
        >
          <div class="header" :class="classHeader(container)" :style="styleHeader(container)">{{ container.title }}</div>
          <div class="header" :class="classHeaderSub(container)" :style="styleHeaderSub(container)">{{ container.subTitle }}</div>
          <!-- Container SVG Download Btn -->
          <div class="section-tools br">
            <v-btn
              icon
              variant="flat"
              density="compact"
              size="13"
              class="btn-svg"
              :title="`Export Container ${i+1} to SVG`"
              >
              <v-icon size="12">mdi-dots-vertical</v-icon>
              <v-speed-dial location="left bottom" activator="parent" open-on-hover>
                <v-btn
                  v-for="(item, j) in dialActions"
                  :key="j"
                  :text="item.text"
                  :class="item.class"
                  @click="(item.text === 'SVG') ? exportSectionAsSVG(i) : (item.text === 'SVG2') ? exportSectionAsSVG2(i) : exportSectionAsPNG(i,container)"
                  >
                </v-btn>
              </v-speed-dial>
            </v-btn>
          </div>
          <!-- Container LINK Btn -->
          <div v-if="exLinkAvailable(container, i)" class="section-link rt">
            <v-btn
              icon
              variant="flat"
              density="compact"
              size="13"
              class="btn-svg"
              :title="`Link`"
              @click="onLinkContainer(i, container)"
              >
              <!-- <v-icon size="12">mdi mdi-arrow-top-right-thin</v-icon> -->
              <!-- <v-icon size="11">mdi mdi-arrow-top-right</v-icon> -->
              <!-- <v-icon size="12">mdi mdi-share</v-icon> -->
              <!-- <v-icon size="12">mdi mdi-share-outline</v-icon> -->
              <!-- <v-icon size="14">mdi mdi-arrow-top-right-thin-circle-outline</v-icon> -->
              <img :src="require('@/assets/img/link.svg')" alt="link" width="16" height="16" />
            </v-btn>
          </div>
          <div 
            v-if="mode == __C_.DASHBOARD.BUILDER_MODE_LAYOUT" 
            :class="`_container_index__${i}_${localId} ${selected(i)}`"
            >
            <header>
              <div class='title'>
                <div class='_index__'><h1>{{i + 1}}</h1></div>
                <div class='container_dimention'>{{ container.width }} x {{ container.height }}</div>
              </div>
              <div class='item_list'>
                <div 
                  v-for="(chartMetaNested, j) in container.items" :key="`chart_info__${i}_${j}`"
                  class="item_info"
                >
                  <span :class="{ removed: !chartAvailable(chartMetaNested.chartNo) }">{{ j+1 }}. {{ chartMetaNested.name }}</span>
                  <span v-if="!chartAvailable(chartMetaNested.chartNo)" class="removed_notice">(removed)</span>
                  <a v-if="!chartAvailable(chartMetaNested.chartNo)" class="btn_remove_text" @click="onRemoveItem(i, j)">
                    <v-icon>mdi-window-close</v-icon>
                  </a>

                </div>
              </div>
            </header>
            <div class='spacer'></div>
          </div>

          <div
            v-for="(chartMetaNested, j) in container.items" 
            class="chart" 
            :class="classChart(chartMetaNested)"
            :id="`__chart_wrapper_${i}_${j}___${localId}`"
            :style="styleChart(chartMetaNested, i)" 
            :key="`chart__${i}_${j}`"
            @click="onChartClicked(i, j, chartMetaNested)"
            >
            <a v-if="mode == __C_.DASHBOARD.BUILDER_MODE_LAYOUT" class="btn_remove" @click="onRemoveItem(i, j)">
              <v-icon>mdi-window-close</v-icon>
            </a>

            <component
              v-if="chartAvailable(chartMetaNested.chartNo)"
              v-bind="vBinds[`${container.containerNo}_${chartMetaNested.chartNo}`]"

              :mode-export="modeExport"
              :getSelectItems="getSelectItems"
              
              :ref="`__ref__chart_item_${i}_${j}___${localId}`"
              :id="`__chart_item_${i}_${j}___${localId}`"
              :is="CAT_CODE_CHART_COMPONENT(chartMetaNested.catCode, chartMetaNested.chartNo)"
              :movable="false"
              :ChartType="chartMetaNested.chartType"
              
              
              :callback="callbackData"

              @request-action="(request) => { onRequestedAction(request, container, chartMetaNested, i) }"              
              @selectedItems ="selectedItems"
            />

          </div>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
import __C from '@/primitives/_constant_'
import '@/assets/stylus/ui/component/_jDashboardLayoutBuilder.scss'
import DashboardMixin from '@/mixins/dashboard.builder.mixin'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export default {
  name: "j-dashboard-layout-builder",
  inject: ['ExportSvg'],
  mixins: [
    DashboardMixin
  ],
  data() {
    return {
      dialActions: [
        { text : 'PNG' , class : 'j_button type05 sky'},
        { text : 'SVG' , class : 'j_button type05 pink'},
        { text : 'SVG2' , class : 'j_button type05 gray'},
      ],
      inlineOptions: { inlineStyles: true, inlineImages: true }
    }
  },
  created() {
    this.localId = this.id || 'j-dashboard-layout-builder__' + this.safeId('')
    // console.log('j-dashboard-layout-builder created')

    // console.log('j-dashboard-layout-builder Has init method:', typeof this.init === 'function')
    // console.log('j-dashboard-layout-builder Mixins:', this.$options.mixins)
  },
  mounted() {
    // LNB에서 버튼클릭시 실행할 핸들러를 등록
    this._exportSvgHandler = (title) => this.exportDashboardAsSVG(title)
    this.ExportSvg && this.ExportSvg.setExportSvgHandler && this.ExportSvg.setExportSvgHandler(this._exportSvgHandler)
  },
  beforeUnmount() {
    this.ExportSvg && this.ExportSvg.clearExportSvgHandler && this.ExportSvg.clearExportSvgHandler(this._exportSvgHandler)
  },
  computed: {
    isSysEnvPath() {
      return this.$route.path.startsWith('/sysenv/')
    },
  },
  beforeUpdate() {
    if (!this.isSysEnvPath) {
      this.localId = this.id || 'j-dashboard-layout-builder__' + this.safeId('')
    }
  },
  methods: {
    async exportDashboardAsSVG(title='dashboard') {
      const root = this.$el
      const sections = root.querySelectorAll('section._dashboard_section_container__')
      if (!sections.length) {
        console.log('Not found sections in dashboard')
        return
      }
      const zip = new JSZip()
      const topFolder = zip.folder(this.slugify(title))
      const usedNames = new Set() // 섹션 폴더명 중복 방지
      let fileCount = 0

      for (let s = 0; s < sections.length; s++) {
        const sec = sections[s]
        // 섹션별 폴더
        const secTitle = this.getSectionTitle(sec, s)
        const secSlug  = this.slugify(secTitle) || `section-${s + 1}`
        const secFolderName = this.uniqueName(`${s + 1}_${secSlug}`, usedNames)
        const secFolder = topFolder.folder(secFolderName)

        // 섹션 하위의 모든 SVG (아이콘/버튼 제외 필요시 필터)
        const allSvgs = Array.from(sec.querySelectorAll('svg')).filter(svg => {
          if (svg.closest('.v-btn,.v-icon,.mdi,.v-overlay,[data-ignore-export]')) return false
          try { const b = svg.getBBox(); if (!b || b.width===0 || b.height===0) return false } catch(e) {
            if ((svg.offsetWidth||0)===0 && (svg.offsetHeight||0)===0) return false
          }
          return true
        })

        for (let i = 0; i < allSvgs.length; i++) {
          const svgEl = allSvgs[i]
          const svgString = await this.serializeSVG(svgEl, this.inlineOptions)
          const fname = `chart_${i+1}.svg`
          secFolder.file(fname, svgString)   // 텍스트로 추가
          fileCount++
        }
      }

      if (!fileCount) {
        console.log('No SVG to export in dashboard')
        return
      }

      const blob = await zip.generateAsync({ type: 'blob' })
      saveAs(blob, `${this.slugify(title)}.zip`)
    },

    async exportSectionAsSVG(i) {
      const section = document.getElementById(`container__${i}_${this.localId}`)
      if (!section) return
      
      // 섹션 하위의 모든 SVG (아이콘/버튼 제외 필요시 필터)
      const allSvgs = Array.from(section.querySelectorAll('svg')).filter(svg => {
        if (svg.closest('.v-btn,.v-icon,.mdi,.v-overlay,[data-ignore-export]')) return false
        try { const b = svg.getBBox(); if (!b || b.width===0 || b.height===0) return false } catch(e) {
          if ((svg.offsetWidth||0)===0 && (svg.offsetHeight||0)===0) return false
        }
        return true
      })

      if (!allSvgs.length) {
        console.log('Not found SVG in section', i)
        return
      }

      const secTitle = this.getSectionTitle(section, i)
      const secSlug  = this.slugify(secTitle) || `section-${i + 1}`
      const zip = new JSZip()      
      const secFolder = zip.folder(`${i + 1}_${secSlug}`)

      if (allSvgs.length > 10) {
        let fileCount = 0
        for (let i = 0; i < allSvgs.length; i++) {
          const svgEl = allSvgs[i]
          const svgString = await this.serializeSVG(svgEl, this.inlineOptions)
          const fname = `chart_${i+1}.svg`
          secFolder.file(fname, svgString)   // 텍스트로 추가
          fileCount++
        }
        
        if (!fileCount) {
          console.log('No SVG to export in dashboard')
          return
        }

        const blob = await zip.generateAsync({ type: 'blob' })
        saveAs(blob, `${this.slugify(secSlug)}.zip`)
        
      } else {
        let idx = 1
        for (const svgEl of allSvgs) {
          const svgString = await this.serializeSVG(svgEl, this.inlineOptions)
          this.downloadSVG(`${this.slugify(secSlug)}_${idx}.svg`, svgString)
          idx++
        }
      }
      
    },

    async exportSectionAsSVG2(i) {
      const section = document.getElementById(`container__${i}_${this.localId}`)
      if (!section) return

      const allSvgs = Array.from(section.querySelectorAll('svg')).filter(svg => {
        if (svg.closest('.v-btn,.v-icon,.mdi,.v-overlay,[data-ignore-export]')) return false
        try { 
          const b = svg.getBBox()
          if (!b || b.width === 0 || b.height === 0) return false
        } catch(e) {
          if ((svg.offsetWidth || 0) === 0 && (svg.offsetHeight || 0) === 0) return false
        }
        return true
      })

      if (!allSvgs.length) {
        console.log('Not found SVG in section', i)
        return
      }

      const secTitle = this.getSectionTitle(section, i)
      const secSlug  = this.slugify(secTitle) || `section-${i + 1}`

      const width  = section.offsetWidth
      const height = section.offsetHeight

      let mergedSVG = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${width}" height="${height}">`

      for (const svgEl of allSvgs) {
        const rect = svgEl.getBoundingClientRect()
        const secRect = section.getBoundingClientRect()

        const offsetX = rect.left - secRect.left
        const offsetY = rect.top - secRect.top

        const svgString = await this.serializeSVG(svgEl, this.inlineOptions)

        const match = svgString.match(/<svg[^>]*>([\s\S]*)<\/svg>/)
        const innerContent = match ? match[1] : ''
        
        if(innerContent) {
          mergedSVG += `<g transform="translate(${offsetX}, ${offsetY})">${innerContent}</g>`
        }
      }

      mergedSVG += '</svg>'

      this.downloadSVG(`${this.slugify(secSlug)}.svg`, mergedSVG)
    },

    exportSectionAsPNG(i, container) {
      let request_ = {
        dataType: 'row',
        action: {
          value   : 'PNG',
          name    : 'File Downloader',
          command : 'exportPng',
          type    : 'direct',
        },
      }
      let container_ = container
      let chartMeta_ = { roleNo : 'CTL-0001'}
      this.onRequestedAction(request_, container_, chartMeta_, i)
    },
    async serializeSVG(svgEl, { inlineStyles = true, inlineImages = true } = {}) {
      const clone = svgEl.cloneNode(true)
      
      clone.setAttribute('version', '1.1')
      clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
      clone.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink')

      clone.removeAttribute('x')
      clone.removeAttribute('y')

      const rect = (typeof svgEl.getBBox === 'function')
        ? svgEl.getBBox()
        : svgEl.getBoundingClientRect()

      const vb = svgEl.getAttribute('viewBox')
      let width  = parseFloat(svgEl.getAttribute('width'))  || (vb ? +vb.split(/\s+/)[2] : rect.width)  || svgEl.clientWidth  || 1200
      let height = parseFloat(svgEl.getAttribute('height')) || (vb ? +vb.split(/\s+/)[3] : rect.height) || svgEl.clientHeight || 800

      width  = Math.max(1, Math.round(width))
      height = Math.max(1, Math.round(height))

      if (!clone.getAttribute('viewBox')) {
        clone.setAttribute('viewBox', `0 0 ${width} ${height}`)
      } else {
        const parts = clone.getAttribute('viewBox').trim().split(/\s+/)
        if (parts.length === 4 && (parts[0] !== '0' || parts[1] !== '0')) {
          clone.setAttribute('viewBox', `0 0 ${parts[2]} ${parts[3]}`)
        }
      }

      clone.setAttribute('width',  String(width))
      clone.setAttribute('height', String(height))

      if (inlineStyles) this.inlineStylesRecursive(clone)
      if (inlineImages) await this.inlineImages(clone)

      const xml = new XMLSerializer().serializeToString(clone)
      return `<?xml version="1.0" encoding="UTF-8"?>\n` + xml
    },

    inlineStylesRecursive(el) {
      const win = el.ownerDocument.defaultView
      const style = win.getComputedStyle(el)
      const cssText = Array.from(style).map(p => `${p}:${style.getPropertyValue(p)}`).join(';')
      if (cssText) el.setAttribute('style', cssText)

      if (style.fill) el.setAttribute('fill', style.fill)
      if (style.stroke) el.setAttribute('stroke', style.stroke)
      if (style.font) el.setAttribute('font', style.font)
      if (style.fontFamily) el.setAttribute('font-family', style.fontFamily)
      if (style.fontSize) el.setAttribute('font-size', style.fontSize)

      for (const child of el.children) this.inlineStylesRecursive(child)
    },

    async inlineImages(svgEl) {
      const imgEls = svgEl.querySelectorAll('image, img')
      for (const img of imgEls) {
        const href = img.getAttribute('href') || img.getAttribute('xlink:href')
        if (!href || href.startsWith('data:')) continue
        try {
          const res = await fetch(href, { mode: 'cors' })
          const blob = await res.blob()
          const dataUrl = await new Promise(resolve => {
            const fr = new FileReader()
            fr.onload = () => resolve(fr.result)
            fr.readAsDataURL(blob)
          })
          img.removeAttribute('href')
          img.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', dataUrl)
        } catch (e) {
          console.log('Fail Inline Image:', href, e)
        }
      }
    },
    slugify(t) {
      return String(t).trim().toLowerCase()
        .replace(/\s+/g,'-').replace(/[^\w\-]+/g,'').replace(/\-+/g,'-')
    },
    getSectionTitle(sectionEl, idx) {
      // 우선순위: .header.regular > .header
      const h1 = sectionEl.querySelector('.header.regular')
      const h2 = sectionEl.querySelector('.header')
      let title = (h1?.textContent || h2?.textContent || '').trim()
      if (!title) title = `section-${idx + 1}`
      return title
    },
    slugify(t) {
      return String(t).trim().toLowerCase()
        .replace(/\s+/g, '-')         // space -> -
        .replace(/[^\w\-]+/g, '')     // 영숫자/언더스코어/대시 외 제거
        .replace(/\-+/g, '-')         // -- -> -
        .replace(/^-+|-+$/g, '')      // 앞뒤 - 제거
    },
    // 중복 폴더명 처리: 뒤에 (_2), (_3) 붙임
    uniqueName(base, used) {
      let name = base
      let n = 2
      while (used.has(name)) { name = `${base}(${n++})` }
      used.add(name)
      return name
    },
    downloadSVG(filename, svgString) {
      const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' })
      const a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = filename.endsWith('.svg') ? filename : filename + '.svg'
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(a.href)
      a.remove()
    },
    onLinkContainer(i, container) {
      this.$router.push(`/service/${container.exLink}`)
    },
  }
}
</script>
